import React, { useCallback } from 'react';
import helpers from '@starflow/app/helpers';
import { useEventListener } from 'ahooks';
import { useTempState, getTempState, setTempState } from '@starflow/app/store';
import { SubWindow } from '../common/Window';

export const SubWindows = React.memo(() => {
  const exclusiveWindow = useTempState('exclusiveWindow');

  // const handleGlobalClick = useCallback((event) => {
  //   const triggerElement = event.target?.closest('[data-trigger-window]');

  //   if (!triggerElement) return;

  //   const openedWindow = getTempState('exclusiveWindow');
  //   const targetWindow = triggerElement?.dataset.triggerWindow;

  //   if (openedWindow === targetWindow) {
  //     // setTempState({ exclusiveWindow: null });
  //   } else {
  //     setTempState({ exclusiveWindow: targetWindow });
  //   }
  // }, []);

  // useEventListener('click', handleGlobalClick);

  return helpers.component.getSubWindowComponents().map(({ Component, config }, index) => {
    if (exclusiveWindow !== config.name) {
      return null;
    }

    return (
      <SubWindow {...config}>
        <Component key={index + '-' + config.name} />
      </SubWindow>
    );
  });
});
